import useStore from '../store/useStore'
import {
  getVerifiedServiceBinding,
  primaryServices,
} from '../utils/firebaseServiceContext'

const useActiveUid = () =>
  useStore((state) => {
    const identity = state.effectiveIdentity
    if (!identity) return undefined
    if (identity.source === 'primary') {
      return identity.uid === primaryServices.auth.currentUser?.uid
        ? identity.uid
        : undefined
    }
    const binding = getVerifiedServiceBinding()
    return binding &&
      binding.targetUid === identity.uid &&
      binding.sessionId === state.impersonationSession?.sessionId
      ? identity.uid
      : undefined
  })

export default useActiveUid
